'use client'

import { useCallback } from 'react'

import { PAYMENT_PROCESSING_KEY } from '@/components/checkout/checkout-start'

import { useAuth } from '@/hooks/use-auth'
import { useWebPushNotificationSubscription } from '@/hooks/use-web-push-notification-subscription'
import { useBannerStore } from '@/stores/banner.store'
import { useNotificationFilterStore } from '@/stores/notification-filter.store'
import { useNotificationStore } from '@/stores/notification.store'
import { useServiceWorkerStore } from '@/stores/service-worker-store'

const useSignOut = () => {
  const resetBannerStore = useBannerStore((state) => state.reset)
  const resetServiceWorkerStore = useServiceWorkerStore((state) => state.reset)
  const resetNotificationFilterStore = useNotificationFilterStore((state) => state.reset)
  const resetNotificationStore = useNotificationStore((state) => state.reset)
  const { unsubscribeToWebPushNotification, hasSubscription, isSupported } = useWebPushNotificationSubscription()
  const { signOut } = useAuth()

  const onLogout = useCallback(async () => {
    // Clear payment processing state before logging out
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(PAYMENT_PROCESSING_KEY)
    }

    resetBannerStore()
    resetServiceWorkerStore()
    resetNotificationFilterStore()
    resetNotificationStore()
    if (hasSubscription && isSupported) {
      await unsubscribeToWebPushNotification()
    }

    await signOut()
    window.location.reload();
  }, [
    resetBannerStore,
    resetServiceWorkerStore,
    resetNotificationFilterStore,
    resetNotificationStore,
    unsubscribeToWebPushNotification,
    hasSubscription,
    isSupported,
    signOut,
  ])

  return onLogout
}

export { useSignOut }
